// eslint-disable
import { GET_CASE_HISTORY_DATA, UPDATE_CASEHISTORY_FETCH_INPROGRESS } from '../../../actions'

const defaultState = {
  historyData: {},
  fetchHistoryInProgress: false,
}

export const getCaseHistoryDataReducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_CASE_HISTORY_DATA:
      return { ...state, historyData: action.payload }
    case UPDATE_CASEHISTORY_FETCH_INPROGRESS:
      return { ...state, fetchHistoryInProgress: action?.inProgress }
    default:
      return state
  }
}
